<template>
    <div id="GoTop" @click="GoTop()">
        <img src="@/assets/img/returnTop.png"  alt="" v-if="flag">
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'YinshiOffcialwebsiteGoTop',
    data() {
        return {
            flag: false
        };
    },
    mounted() {
        // 监听页面滚动事件
        window.addEventListener("scroll", this.scrolling);
    },
    created(){
    },
    methods: {
        ...mapMutations(['GoTop']),
        scrolling(){
            var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            if(currentScroll < 200){
                this.flag = false
            }else{
                this.flag = true
            }
        }
    },
    beforeDestroy(){
        window.removeEventListener("scroll", this.scrolling);
    }
};
</script>

<style lang="scss" scoped>
#GoTop {
    width: 28px;
    height: 28px;
    position: fixed;
    right: 60px;
    bottom: 30px;
    z-index: 99999999;
    cursor: pointer;
    img{
        width: 28px;
        height: 28px;
    }
}
</style>